import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../Helper/BaseUrl";
import { toastErrorr } from "../../Helper/ToastMessage";

export const ALLMainPanelityPDFReportTableDataAPI = createAsyncThunk("ALLMainPanelityPDFReportTableData", async ({ data }) => {
    const {
        M_ProjectTypeID,
        M_FinancialYearID,
        M_MonthID,
        FromDate,
        Todate,
        M_ContractorID,
        M_ProjectID,
        M_WardID,
        UserID,
        token,
        Flag,
        handleGetPDFUrl
    } = data


    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    let url;
    if (M_ProjectTypeID == "7") {
        url = `${BaseUrl}/APKDashboard/Get_RM_DB_PENALTY_WTP_SELECT?M_ProjectTypeID=${M_ProjectTypeID ? M_ProjectTypeID : '0'}&M_FinancialYearID=${M_FinancialYearID ? M_FinancialYearID : '0'}&M_MonthID=${M_MonthID ? M_MonthID : '0'}&FromDate=${FromDate}&Todate=${Todate}&M_ContractorID=${M_ContractorID ? M_ContractorID : '0'}&M_ProjectID=${M_ProjectID ? M_ProjectID : '0'}&M_WardID=${M_WardID ? M_WardID : '0'}&Flag=${Flag}&M_UserID=${UserID}`
    } else {
        url = `${BaseUrl}/APKDashboard/Get_RM_DB_PENALTY_WS_SELECT?M_ProjectTypeID=${M_ProjectTypeID ? M_ProjectTypeID : '0'}&M_FinancialYearID=${M_FinancialYearID ? M_FinancialYearID : '0'}&M_MonthID=${M_MonthID ? M_MonthID : '0'}&FromDate=${FromDate}&Todate=${Todate}&M_ContractorID=${M_ContractorID ? M_ContractorID : '0'}&M_ProjectID=${M_ProjectID ? M_ProjectID : '0'}&M_WardID=${M_WardID ? M_WardID : '0'}&Flag=${Flag}&UserID=${UserID}`
    }

    return fetch(url, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300) {
                { Flag == 'PDF_Report' && handleGetPDFUrl(result.url) }
                return result.data
            } else {
                // toastErrorr(result.message)
                return result
            }
        })
})

const ALLMainPanelityPDFReportTableDataSlice = createSlice({
    name: "ALLMainPanelityPDFReportTableData",
    initialState: {
        isLoading: false,
        pdftableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(ALLMainPanelityPDFReportTableDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(ALLMainPanelityPDFReportTableDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.pdftableData = action.payload;
        });
        builder.addCase(ALLMainPanelityPDFReportTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.pdftableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const ALLMainPanelityPDFReportTableDataReducer = ALLMainPanelityPDFReportTableDataSlice.reducer